export const config = {
  API_BASE: window._env.API_BASE,
    // API_BASE: 'https://api.brightbee.co/api/',
    // API_BASE:'http://127.0.0.1:4000/api/',
    BASE_URL: window._env.BASE_URL,
    GS_BUCKET_URL: window._env.GS_BUCKET_URL,
    IMG_URL: window._env.IMG_URL,
    STRIPE_KEY: window._env.STRIPE_KEY,
}
